import { render } from "./ShippingServiceIndex.vue?vue&type=template&id=7807c648&scoped=true"
import script from "./ShippingServiceIndex.vue?vue&type=script&lang=js"
export * from "./ShippingServiceIndex.vue?vue&type=script&lang=js"

import "./ShippingServiceIndex.vue?vue&type=style&index=0&id=7807c648&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7807c648"]])

export default __exports__